'use client';

import ForBrokersIcon from '@icons/ForBrokers.svg';
import RewardIcon from '@icons/reward.svg';
import TrendingIcon from '@icons/trend.svg';
import BrokerHeroImage from '@images/use-cases/BrokerHeroImage.webp';
import { Containers, Widgets } from '@components';
import { CompanySubnav } from '@/components/elements/CompanySubnav';
import { BROKERS_SWITCHING_TO_PB_CARDS } from '@/utils/content/brokersSwitchingToPB';
import { BROKERS_TROJAN_HORSE_CARDS } from '@/utils/content/brokersTrojanHorse';
import { BROKERS_WHAT_BROKERS_ARE_SAYING_SLIDES } from '@/utils/content/brokersWhatBrokersAreSaying';

export default function BrokersPage() {
    return (
        <>
            <CompanySubnav section="use-cases" currentLabel="Brokers" />
            <Containers.Section
                el={
                    <Widgets.UseCasesHero
                        badge={{
                            iconSrc: ForBrokersIcon,
                            label: 'For Brokers',
                        }}
                        title="Protect Your BOR and Scale with White-Labeled ICHRA"
                        description="Predictable Benefits gives you a white-labeled ICHRA platform — your brand, your pricing, your BOR. Keep 100% of your commissions and grow into clients you used to decline."
                        image={{
                            src: BrokerHeroImage,
                            alt: 'A smiling professional in a blue shirt at a desk in a bright office, writing in a notebook.',
                            priority: true,
                        }}
                        overlayCardsPositionClassName="bottom-[65%] right-3 md:bottom-[70%] md:right-4 lg:bottom-3 lg:right-3 lg:-translate-x-80"
                        overlayCards={[
                            {
                                title: 'Grow Your Agent Network',
                                subtitle:
                                    'Recruit and retain top-performing brokers',
                                iconSrc: TrendingIcon,
                                className: 'w-full max-w-[320px] shrink-0',
                            },
                            {
                                title: 'Own the Relationship',
                                subtitle: 'Stay at the center of every deal',
                                iconSrc: RewardIcon,
                                className: 'w-full max-w-[290px] shrink-0',
                            },
                        ]}
                    />
                }
            />
            <Containers.Section
                el={
                    <Widgets.TrojanHorseSection
                        cards={BROKERS_TROJAN_HORSE_CARDS}
                    />
                }
            />
            <Containers.Section
                el={
                    <Widgets.SwitchingToPBSection
                        cards={BROKERS_SWITCHING_TO_PB_CARDS}
                    />
                }
            />
            {/* <Containers.Section
                el={
                    <Widgets.WhatBrokersAreSaying
                        slides={BROKERS_WHAT_BROKERS_ARE_SAYING_SLIDES}
                    />
                }
            /> */}
            <Containers.Section
                el={<Widgets.ExploreOtherUseCases excludeSlug="brokers" />}
            />
            <Containers.Section el={<Widgets.ReadToBuild />} />
        </>
    );
}
